module.exports = require("@material-ui/icons/DeleteForever");;